// Lib
import { findWithRegex } from '@draft-js-plugins/utils';

// Utils
import getQueryRegex, { QueryMode } from '../../../../../common/utils/getQueryRegex';

export default (searchTerm) => {
    const searchTermRegEx = getQueryRegex(searchTerm, QueryMode.PHRASE, 'gi');
    return (contentBlock, callback, contentState) => findWithRegex(searchTermRegEx, contentBlock, callback);
};
